<template>
  <div>
    <el-form ref="form" :model="formData" size="small" :rules="rules" :disabled="disabled">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="this.$l('form_label_title_review')||'评审状态'">
            <el-radio-group size="small" v-model="formData.reviewStatus">
              <el-radio-button label="Y"> {{this.$l('form_label_adopt')||'通过'}}  </el-radio-button>
              <el-radio-button label="N"> {{this.$l('form_label_Fail')||'未通过'}} </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="this.$l('form_label_reviewDesc')||'评审意见'" prop="reviewDesc">
            <el-input
              type="textarea"
              :placeholder="this.$l('tips_input_reviewComments')||'请输入评审意见'"
              v-model="formData.reviewDesc"
              :rows="3"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import EditLoading from "@/mixins/edit-loading"
import validate from '@/libs/util.validate'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    orderCode: String,
    cancelOrderCode: String,
    code: String,
    type: String,
  },
  data() {
    return {
      formData: { reviewStatus: "Y", isFinal: "N" },
      reviewStatusParams: { dictType: "reviewStatus" },
      rules: {
        reviewDesc: [
          {
            required: true,
            message: this.$l('tips_input_reviewComments') || '请输入评审意见',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData(this.code)
  },
  methods: {
    getData(code) {
      if (!this.code) return
      this.$api
        .cancelOrderReviewDetailApi({ cancelOrderReviewCode: code })
        .then((res) => {
          this.formData = res.body
        })
        .catch(() => {
        })
    },
    async saveOrderReview() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      this.$confirm(
        "是否保存该评审记录",
        this.$l("INDEX.label_completeDesc") || "确认信息",
        {
          confirmButtonText:
            this.$l("INDEX.product_dialog_btn_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.btn_cancel") || "取消",
          type: "warning",
        }
      ).then(() => {
        this.loadingOpen()
        if (this.type === "addFinal") {
          this.formData.isFinal = "Y"
        }
        this.$api
          .cancelOrderReviewSaveApi({
            cancelOrderCode: this.cancelOrderCode,
            orderCode: this.orderCode,
            ...this.formData,
          })
          .then((res) => {
            this.loadingClose()
            const { status } = res
            if (status == 200) {
              this.$message({
                message: this.$l("INDEX.tips_save_ok") || "保存成功",
                type: "success",
              })
              if (this.type === "addFinal") {
                this.$emit("closeDialog")
                this.$emit("saveOkQuestion")
                return
              }
              this.$emit("closeDialog")
              this.$emit("reload")
            }
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.aas {
  margin-left: 4%;
}
</style>
